var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDialogs = function SvgDialogs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.63699 9.99967L0.666992 12.333V1.99967C0.666992 1.82286 0.73723 1.65329 0.862254 1.52827C0.987279 1.40325 1.15685 1.33301 1.33366 1.33301H11.3337C11.5105 1.33301 11.68 1.40325 11.8051 1.52827C11.9301 1.65329 12.0003 1.82286 12.0003 1.99967V9.99967H3.63699ZM3.17566 8.66634H10.667V2.66634H2.00033V9.58967L3.17566 8.66634ZM5.33366 11.333H12.1583L13.3337 12.2563V5.33301H14.0003C14.1771 5.33301 14.3467 5.40325 14.4717 5.52827C14.5968 5.65329 14.667 5.82286 14.667 5.99967V14.9997L11.697 12.6663H6.00033C5.82351 12.6663 5.65395 12.5961 5.52892 12.4711C5.4039 12.3461 5.33366 12.1765 5.33366 11.9997V11.333Z"
  })));
};
export default SvgDialogs;